export const OPEN_DROPDOWN = "OPEN_DROPDOWN";
export const CLOSE_DROPDOWN = "CLOSE_DROPDOWN";
export const MY_ACCOUNT = "myAccount";
export const MINIBAG = "miniBag";
export const SAVED_ITEMS = "savedItems";
export const SEARCH = "search";
export const DROPDOWN_NAMES = [MY_ACCOUNT, MINIBAG];
